/* eslint-disable no-undef */
import { AUTH_PATH } from "../router/path/auth";
import { WIZARD_STEP_PATH } from "../router/path/wizard";
import { store } from "../store";

export const setRightRoute = (prefix, route, firstRoute) => {
  const authRoutes = Object.values(AUTH_PATH).flatMap((item) => [
    `/${item}`,
    `/${item}/`,
    `/${prefix}/${item}`,
    `/${prefix}/${item}/`,
  ]);
  const wizardRoutes = Object.values(WIZARD_STEP_PATH).flatMap((item) => [
    `/wizard/${item}`,
    `/wizard/${item}/`,
    `/${prefix}/${item}`,
    `/${prefix}/${item}/`,
  ]);

  if (route?.includes(`/${AUTH_PATH.OAUTH_CALLBACK_GOOGLE}`)) {
    window.location.href = firstRoute;
  }

  if (
    authRoutes.includes(route) ||
    wizardRoutes.includes(route) ||
    route === `/${prefix}` ||
    route === `/${prefix}/`
  ) {
    return "";
  }

  return route || "";
};
export const openChat = () => {
  if (typeof HubSpotConversations !== "undefined") {
    window.HubSpotConversations.widget.open();
  }
};

export const openChatWithMessage = (message) => {
  // not supported HubSpot Chat
  if (typeof HubSpotConversations !== "undefined") {
    window.HubSpotConversations.widget.open();
  }
};

export const closeChat = () => {
  if (typeof HubSpotConversations !== "undefined") {
    window.HubSpotConversations.widget.close();
  }
};

export const hideChatWidget = () => {
  if (typeof HubSpotConversations !== "undefined") {
    window.HubSpotConversations.widget.remove();
  }
};

export const redirectToLoginIfUnauthorized = (result, args) => {
  const { access_token } = store.getState().auth;

  if (
    access_token &&
    args?.url !== "/profile" &&
    result.meta?.response.status === 401
  ) {
    window.location.reload();
  }
};

export const COOKIE_DOMAIN = ".shopping-cart-migration.com";
export const PUBLIC_DOMAIN = "shopping-cart-migration.com";
export const ONE_YEAR_MS = 365 * 24 * 60 * 60 * 1000;

export const detectAdBlock = async () => {
  const testAd = document.createElement("div");
  testAd.className = "adsbox ad ad-banner ad-slot adsbygoogle";
  testAd.style.cssText =
    "width: 1px; height: 1px; position: absolute; top: -1000px; left: -1000px;";
  document.body.appendChild(testAd);

  const isDomBlocked =
    getComputedStyle(testAd).display === "none" ||
    testAd.offsetHeight === 0 ||
    testAd.offsetParent === null;

  document.body.removeChild(testAd);

  const isRequestBlocked = await new Promise((resolve) => {
    const xhr = new XMLHttpRequest();
    xhr.open(
      "GET",
      "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js",
    );
    xhr.onload = () => resolve(false);
    xhr.onerror = () => resolve(true);
    try {
      xhr.send();
    } catch (e) {
      resolve(true);
    }
  });

  return isDomBlocked || isRequestBlocked;
};

export const setCookieWithExpiry = (setCookie, name, value) => {
  setCookie(name, value, {
    path: "/",
    domain: COOKIE_DOMAIN,
    expires: new Date(Date.now() + ONE_YEAR_MS),
  });
};

export const setShopifyCookie = (cookies) => {
  if (!cookies || typeof cookies !== "object") return;
  const maxAge = 86400;
  const expires = new Date(Date.now() + maxAge * 1000).toUTCString();

  Object.entries(cookies).forEach(([key, value]) => {
    document.cookie = `${key}=${encodeURIComponent(
      value,
    )}; expires=${expires}; max-age=${maxAge}; path=/; domain=${COOKIE_DOMAIN}; secure; samesite=none`;
  });
};
